
import { LocalizationProvider } from '@mui/x-date-pickers-v.6/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers-v.6/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers-v.6/DateTimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers-v.6/timeViewRenderers';
import { DateTimeSetupValue } from './DateTimeSetupValue';
import type { DateTimeValue, SetupValueProps } from '../types';
import { FormField } from '../../types';

const DateTime = ({
    values,
    onChange
}: SetupValueProps<DateTimeValue>) => (
    <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateTimePicker
            slotProps={{
                textField: {
                    size: 'small',
                    fullWidth: true
                }
            }}
            ampm={false}
            label='DateTime Setup Value'
            value={values[FormField.SetupValue].value}
            format={DateTimeSetupValue.format}
            onChange={onChange}
            viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
            }}
        />
    </LocalizationProvider>
);

export default DateTime;
